<template>
  <div class="row back">
    <div class="col-sm-4 col-md-4 col-xl-3 mx-auto my-auto">
      <img src="../../assets/newDesign/404.svg" class="page-not-found" />
      <div>
        <h1 style="font-weight:bold; color:#050405;margin:3.0rem .0rem;">
          Page not found let's <br /><a
            class="btn btn-save"
            style="color:white;width:auto !important; margin-top:2.0rem"
            @click="goBack"
            ><b>GO BACK</b></a
          >
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      path: "/",
      flag: true
    };
  },
  beforeRouteEnter(to, from, next) {
    // eslint-disable-next-line
    const self = this;
    // eslint-disable-next-line
    next((self, vm) => {
      if (from.name) self.path = from.name;
      else self.flag = false;
    });
  },
  methods: {
    goBack: function() {
      this.flag ? this.$router.push({ name: this.path }) : this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.page-not-found {
  width: 100%;

  height: auto;
}
.link {
  color: #fbff00 !important;
}
.back {
  height: 100vh;
  position: fixed;
  width: 100vw;
  top: 0rem;
  left: 0rem;
  z-index: 9999;
  background-color: white;
  /* background-image: url("../../assets/newDesign/404back.svg"); 
  background-position: center; 
  background-repeat: no-repeat; 
  background-size: cover; */
}
</style>
